const guessColumnIndex = ({ fileData, headingMatcher }) => {
  const headers = fileData[0];

  for (let index = 0; index < headers.length; index += 1) {
    const header = headers[index];
    if (headingMatcher.test(header)) {
      return index;
    }
  }

  return null;
};

export default guessColumnIndex;
